import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { fetchNavMenus } from '../../reducers/reference_navmenu';
import { fetchClientLogos } from '../../reducers/reference_clientlogo';
import HeaderLogo from './HeaderLogo';
import HeaderMenu from './HeaderMenu';
import { Button, Grid } from '@mui/material';
import { authClear} from '../../reducers/auth';
import { userTimeoutSecondsRemaining } from '../../reducers/auth_timeout';
import { Print } from '@mui/icons-material';

import {useTheme} from "@mui/material/styles"
import { globalsettingGetPrioritySesOrgPer, selectGlobalSettingEntities, selectSettingForTypeKeyName } from '../../reducers/reference_settings';
// import { fetchTranslations } from '../../reducers/reference_translations';

const pages = [];

const Header = (props) => {
  const navigate = useNavigate()
  const {
    user: currentUser
    , behalfOfUser: behalfOf
    , mainUser: mainUser
    , status: authStatus
    , statusSwitch: statusSwitch
    , statusBehalf: statusBehalf
  } = useSelector((state) => state.auth);
  
  // const {
    
  //  timeoutRemaining: timeoutRemaining
  //   , isTimedOut: isTimedOut
  // } = useSelector((state)=> state.timeouts)

  const theme = useTheme()

  const clientLogoStatus = useSelector(state => state.clientlogo.status)
  const navmenuStatus = useSelector(state => state.navmenu.status)
  // const translationStatus = useSelector(state => state.translations.status)
  const {settings} = useSelector(state => state.viewinstance)
  const globalsettings = useSelector(state=>selectGlobalSettingEntities(state))
  const themeColor = useSelector(state=>selectSettingForTypeKeyName(state,{SettingTypeKeyName:'THEME COLOR'}))
  const dispatch = useDispatch();
  const location = useLocation();
  const IsBehalf = behalfOf && behalfOf.AuthToken ? true : false
  const {

    timeoutRemaining: timeoutRemaining
    , isTimedOut: isTimedOut
} = useSelector((state) => state.timeouts)
  useEffect(() => {
    if (navmenuStatus === 'idle' && authStatus === 'success') {
      dispatch(fetchNavMenus({ authToken: currentUser.AuthToken }))
    }
  }, [])

  useEffect(() => {
    
    if ((currentUser.PasswordChangeRequired === true) && (location.pathname != '/pwreset')&& (location.pathname != '/logout') &&(!isTimedOut) && (!behalfOf.AuthToken)) {
      
      navigate("/pwreset");
    } 
    }, [location.pathname])

  useEffect(() => {
    if (clientLogoStatus === 'idle' && authStatus === 'success') {
      dispatch(fetchClientLogos({ authToken: currentUser.AuthToken }))
    }
  }, [])

  useEffect(() => {
 
  }, [theme])



    return (
    <AppBar position="static" style={{ position: "absolute", top: '0', left: '0', backgroundColor: '#ffffff' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Grid container direction="row" alignItems="center" justifyContent="center">
            <Grid item xs={4} md={4}>

              {
                clientLogoStatus !== 'success' ?
                  (

                    <Skeleton variant="rectangular" animation="wave">
                      <div style={{ width: '100px', height: '50px' }} />
                    </Skeleton>
                  )
                  : (
                    <HeaderLogo />

                  )
              }
            </Grid>
            <Grid item xs={6} md={6}>

              <Typography
                variant="body2"
                fontStyle="align"
                color="error"
                align="center"
              >
                {
                  behalfOf && behalfOf.AuthToken ? "Logged in as a participant" : ""
                }
              </Typography>
            </Grid>

            <Grid item xs={2} md={2}>
              <Grid container direction="row" alignItems="center" justifyContent="center">

                {props.printFunction && (
                  <Grid item xs={6} >
                    <Box justifyContent="end">

                      <Button variant="text" onClick={() => { props.printFunction() }} aria-label="print">
                        <Print fontSize="medium" />
                      </Button>
                    </Box>
                  </Grid>
                )}

                <Grid item xs={6} >
                  <Box  justifyContent="end">
                    {
                      navmenuStatus !== 'success' ?
                        (

                          <Skeleton variant="circular" animation="wave">
                            <div style={{ width: '20px', height: '20px' }} />
                          </Skeleton>
                        )
                        : (
                          <HeaderMenu />
                        )
                    }
                  </Box>
                </Grid>
              </Grid>


            </Grid>
          </Grid>
        </Toolbar>
      </Container>
    </AppBar>
  );

  
};

export default Header;